import { CircularProgress, Typography } from '@mui/material';
import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import PropTypes from 'prop-types';

const styles = {
  base: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      paddingRight: '6px',
    },
  },
  valid: {
    color: (theme) => theme.palette.success.dark,
  },
  warning: {
    color: (theme) => theme.palette.gray.dark,
  },
  inValid: {
    color: (theme) => theme.palette.error.main,
  },
}

export default function ValidityIndicator({ isValid, text }) {
  const invalid = isValid !== undefined && !isValid;
  let icon = <CircularProgress size={16} />;
  if (invalid) {
    icon = <ErrorOutlineRoundedIcon />;
  } else if (isValid) {
    icon = <CheckRoundedIcon />;
  }
  return text ? (
    <Typography
      sx={[
        styles.base,
        isValid && styles.valid,
        invalid && styles.inValid,
        !isValid && !invalid && styles.warning
      ]}
    >
      <span>{text}</span>
      {icon}
    </Typography>
  ) : null;
}

ValidityIndicator.propTypes = {
  isValid: PropTypes.bool,
  text: PropTypes.string,
};
